import React, {PureComponent} from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import config from 'config'

import myLibraryActions from '../../../../redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import Modalizer from 'components/modalizer/modalizer'

import styles from './my_library_save_changes_modal.scss'

import PostMessage from 'decorators/postmessage_decorator/PostMessage'

class MyLibrarySaveChangesModal extends PureComponent {

	constructor() {
		super()
		this.handleCloseModalAction = this.handleCloseModalAction.bind(this)
	}

	handleCloseModalAction() {
		this.props.actions.closeSaveChangesModal()
	}

	onMessageEvent = () => {
		this.props.actions.lessonDataSaved(this.props.entity)
	}

	render() {
		const url = config.ct + 'presentationsData.php?presentationId=' + this.props.entity.data.id + '&extraData=true&template=true'
		return (
		//TODO: fix the style on the iframe!
			<Modalizer width='677px' height='600px' modalName={this.props.modalName} closeAction={this.handleCloseModalAction}>

				<PostMessage
					onMessageEvent={this.onMessageEvent}
				>
					<iframe src={url}
						styleName="wrapper"
					/>
				</PostMessage>

			</Modalizer>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeSaveChangesModal: myLibraryActions.closeSaveChangesModal,
		lessonDataSaved: myLibraryActions.lessonDataSaved,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(CSSModules(MyLibrarySaveChangesModal, styles, {allowMultiple: true}))
